<template>
  <div id="features" class="mb-6">
    <div class="bg-grey-lightest">
      <img
        :src="require('@/assets/images/logo/secondary-logo.png')"
        height="50"
        width="150"
        alt="flygate image"
        class="my-2"
      />
      <b-card
        bg-variant="primary"
        text-variant="white"
        class="container mx-auto px-6 pt-32"
      >
        <h1 class="text-center text-white font-weight-bolder text-2xl">
          Welcome to Fly-Gate Payment Gateway Portal
        </h1>

        <div
          class="flex md:flex-no-wrap xs:flex-wrap items-center justify-center mt-24"
        >
          <div class="mt-4 text-center">
            <p class="text-white font-weight-bold text-sm">
              Click the button below to access your dashboard and manage your
              transaction.
            </p>
            <b-button
              class="mt-4"
              :to="{ name: 'dashboard-flyGate' }"
              variant="info"
              >Get Started</b-button
            >
          </div>
        </div>
      </b-card>
      <h1 class="text-center text-dark font-weight-bolder text-xl">
        Supported Payment Types
      </h1>
      <b-row
        class="flex md:flex-no-wrap xs:flex-wrap items-center justify-between mt-24"
      >
        <b-col class="text-center">
          <img
            :src="require('@/assets/images/1.png')"
            width="200"
            alt="flygate image"
          />
        </b-col>
        <b-col class="text-center">
          <img
            :src="require('@/assets/images/2.png')"
            width="200"
            alt="flygate image"
          />
        </b-col>
        <b-col class="text-center">
          <img
            :src="require('@/assets/images/3.png')"
            width="200"
            alt="flygate image"
          />
        </b-col>
        <b-col class="text-center">
          <img
            :src="require('@/assets/images/4.png')"
            width="200"
            alt="flygate image"
          />
        </b-col>
        <b-col class="text-center">
          <img
            :src="require('@/assets/images/5.png')"
            width="200"
            alt="flygate image"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BCard, BButton, BRow, BCol } from "bootstrap-vue";
export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
  },
  data() {
    return {};
  },
};
</script>
